//criar funcionalidade de autenticação
import PouchDB from "pouchdb-browser"
import PouchAuth from "pouchdb-authentication"
import { UserAuth } from "../config/data.types";
import { db } from "./db";


PouchDB.plugin(PouchAuth);

console.log("enviroments variables",process.env.PARCEL_BASE_URL,process.env.PARCEL_BASE_AUTH,process.env.PARCEL_USER_NAME,process.env.PARCEL_DB_NAME,process.env.PARCEL_USER_PASS);
const baseUrl = process.env.PARCEL_BASE_URL;
const baseAuth = process.env.PARCEL_BASE_AUTH ;
const userName = process.env.PARCEL_USER_NAME;
const dbName = process.env.PARCEL_DB_NAME;
const pass = process.env.PARCEL_USER_PASS;

export type AuthResult = {status:"ok",row:UserAuth} | {status:"error",mensagem:string};
export const auth = {
    db: new PouchDB(baseUrl + baseAuth, { skip_setup: true }),
    async signin(login:string,pass:string):Promise<AuthResult>{
        try {
            const resp = await auth.db.logIn(login, pass, {fetch: (url, opts) => fetch(url, { ...opts, credentials: 'include' /* OR 'same-origin' */ })});        
            if(resp.ok){
                //buscar metadados do usuario
                const respUser = await auth.db.getUser(resp.name);
                console.log("respUser",resp);
                const user = respUser as UserAuth;
                //gravar usuario no storage local, caso esteja ativo
                if(user.metadados.active){
                    localStorage.setItem("user", JSON.stringify(user));
                    //salvar a senha criptografada
                    localStorage.setItem("user_pass", btoa(pass));
                    db.connect({
                        db:user.metadados.db_name,
                        login:user.name,
                        pass:pass
                    })
                    return {status:"ok",row:user}
                } else {
                    return { status: "error", mensagem: "Sua empresa não está autorizada a usar o aplicativo, entre em contato com o suporte!"};
                }
            } else {
                return { status: "error", mensagem: "Error desconhecido, tente outra vez!"};
            }
        } catch (error:any) {
            console.log("ERROR LOGIN",error);
            let msg:string = "Verifique sua conexão.";
            if(error.status === 403)
                msg = "Esse usuário não esta autorizado a acessar o aplicativo. "
            if(error.status === 401)
                msg = "Email de usuário ou senha está incorreto, tente outra vez. "
            return {status:"error",mensagem: msg+error.error}
        }   
    },
    async singInFast():Promise<AuthResult>{
        try {
            let userString = userName;
            let passString = pass
            if(userString && passString){
                let pass = atob(passString);
                let resp = await db.connect({
                    db:dbName,
                    login:userName,
                    pass:pass
                })
                if(resp.status === "ok")
                    return {status:"ok",row:{name:userName,} as UserAuth};
                return {status:"error", mensagem:resp.msg};
            } else {
                return {status:"error",mensagem:"Nenhum usuário logado"};
            }
        } catch (error:any) {
            console.log("ERROR SINGINFAST",error);
            return {status:"error",mensagem:"Erro ao recuperar usuário logado: "+error.message};
        }

    }
}